import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../lib/auth';
import { useI18n } from '../lib/i18n';
import Header from '../components/Header';
import { Button } from '../components/ui/button';
import { errText } from '../components/AuthBits';

export default function Register() {
  const { register } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const [f, setF] = useState({ name: '', email: '', password: '', role: 'buyer', phone: '' });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register({ ...f, email: f.email.trim() || null });
      toast.success('Compte créé');
      nav('/');
    } catch (err) { toast.error(errText(err) || 'Error'); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-md mx-auto px-4 py-14">
        <div className="card-elev rounded-3xl p-7">
          <h1 className="font-display text-3xl font-extrabold">{t('register')}</h1>
          <form onSubmit={submit} className="mt-6 space-y-3">
            <input data-testid="register-name" type="text" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder={t('name')}
              className="w-full px-4 py-3 rounded-xl bg-slate-900 border border-slate-700 text-white placeholder-slate-500 focus:border-sky-400 outline-none" />
            <input data-testid="register-phone" type="tel" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} placeholder="Téléphone — ex. 77 123 45 67"
              className="w-full px-4 py-3 rounded-xl bg-slate-900 border border-slate-700 text-white placeholder-slate-500 focus:border-sky-400 outline-none" />
            <input data-testid="register-email" type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="E-mail (optionnel si vous avez un téléphone)"
              className="w-full px-4 py-3 rounded-xl bg-slate-900 border border-slate-700 text-white placeholder-slate-500 focus:border-sky-400 outline-none" />
            <input data-testid="register-password" type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} placeholder={t('password')} autoComplete="new-password"
              className="w-full px-4 py-3 rounded-xl bg-slate-900 border border-slate-700 text-white placeholder-slate-500 focus:border-sky-400 outline-none" />
            <p className="text-[11px] text-slate-500" data-testid="register-hint">Téléphone <strong className="text-slate-300">ou</strong> e-mail suffit : vous vous connecterez avec l'un ou l'autre + votre mot de passe. La même adresse ou le même numéro peut ouvrir un compte acheteur <strong className="text-slate-300">et</strong> une boutique.</p>
            <div className="flex gap-2">
              {['buyer', 'seller'].map((r) => (
                <button key={r} type="button" data-testid={`register-role-${r}`}
                  onClick={() => setF({ ...f, role: r })}
                  className={`flex-1 py-3 rounded-xl border-2 ${f.role === r ? 'border-sky-500 bg-sky-500/10 text-white' : 'border-slate-700 text-slate-300'}`}>
                  {t(r)}
                </button>
              ))}
            </div>
            <Button disabled={busy} type="submit" data-testid="register-submit"
              className="w-full btn-brand text-white py-6 rounded-xl font-bold">{t('register')}</Button>
          </form>
          <div className="my-5 flex items-center gap-3 text-slate-500 text-xs">
            <div className="flex-1 h-px bg-slate-800" />{t('or')}<div className="flex-1 h-px bg-slate-800" />
          </div>
          <Button data-testid="google-register-btn" variant="outline"
            onClick={() => { window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(window.location.origin + '/auth/callback')}`; }}
            className="w-full py-6 rounded-xl border-slate-700 hover:bg-slate-800 text-slate-100 bg-transparent">
            <svg className="h-4 w-4 mr-2" viewBox="0 0 24 24"><path fill="#EA4335" d="M12 5.4c1.7 0 3.2.6 4.3 1.6l3.2-3.2C17.4 1.8 14.9.8 12 .8 7.4.8 3.4 3.4 1.4 7.3l3.8 3C6.2 7.5 8.9 5.4 12 5.4z"/><path fill="#34A853" d="M12 23.2c2.9 0 5.4-1 7.2-2.7l-3.5-2.7c-1 .7-2.3 1.1-3.7 1.1-3.1 0-5.7-2-6.7-4.9l-3.8 2.9c1.9 3.9 5.9 6.3 10.5 6.3z"/><path fill="#4285F4" d="M23.2 12.3c0-.8-.1-1.6-.2-2.4H12v4.6h6.3c-.3 1.5-1.2 2.7-2.5 3.6l3.5 2.7c2-1.9 3.9-4.7 3.9-8.5z"/><path fill="#FBBC05" d="M5.3 14.1a6.7 6.7 0 0 1 0-4.2l-3.8-3A11.2 11.2 0 0 0 .8 12c0 1.8.4 3.5 1.2 5z"/></svg>
            {t('google_login')}
          </Button>
          <div className="mt-6 text-center text-sm text-slate-400">
            <Link to="/login" className="text-sky-400 hover:underline">{t('login')}</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
